import { Sortable, Swap, MultiDrag } from 'sortablejs';
import { DURATION_SHORT_3 } from './animations';

export function createSortableDrag(el: HTMLElement, options?: any): any {
  if (options?.swap) {
    Sortable.mount(new Swap());
  }
  if (options?.multiDrag) {
    Sortable.mount(new MultiDrag());
  }
  const defaultOptions = {
    group: null,
    sort: true,
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: 0,
    disabled: false,
    store: null,
    animation: DURATION_SHORT_3,
    handle: '.sy-drag-handle',
    filter: '.sy-drag-disabled',
    preventOnFilter: true,
    draggable: '.sy-drag-item',

    ghostClass: 'sy-drag-ghost',
    chosenClass: 'sy-drag-chosen',
    dragClass: 'sy-drag-dragging',

    direction: 'horizontal',
  };

  const config = {
    ...defaultOptions,
    ...options,
  };

  const sortable = new Sortable(el, config);

  return sortable;
}
